export default __webpack_public_path__ + "static/media/founder.c497b32c.jpg";